// PaymentDialog.jsx
import React from "react";
import { Dialog, Alert, Pane, Button } from "evergreen-ui";
import { FaReceipt } from "react-icons/fa";
import { IoQrCodeOutline } from "react-icons/io5";

export default function PaymentDialog({ isOpen, onClose }) {
    const handleClose = () => {
        localStorage.removeItem("TERMPAY");
        localStorage.removeItem("FNAME");
        localStorage.removeItem("LNAME");
        localStorage.removeItem("ID_NO");
        localStorage.removeItem("STOPDATE");
        localStorage.removeItem("AMOUNT");
        onClose(); // ส่งกลับไป parent เพื่อ setModalPay(false)
    };

    const idNo = localStorage.getItem("ID_NO");
    const amount = localStorage.getItem("AMOUNT");
    const stopDate = localStorage.getItem("STOPDATE");
    const term = localStorage.getItem("TERM");
    const fname = localStorage.getItem("FNAME");
    const lname = localStorage.getItem("LNAME");

    return (
        <Dialog
            isShown={isOpen}
            title="ชำระเงินค่าสมัคร"
            hasFooter={false}
            onCloseComplete={handleClose}
        >
            <Alert intent="info">
                ท่านสามารถชำระเงินค่าสมัครสอบคัดเลือก ช่องทางธนาคาร หรือชำระเงินค่าสมัครออนไลน์ได้
            </Alert>

            <Pane
                elevation={1}
                padding={10}
                borderRadius={6}
                marginY={20}
                flexDirection={"column"}
                display={"flex"}
                gap={10}
            >
                <Button
                    onClick={() => {
                        window.open(
                            "https://admission.kpru.ac.th/admission2017/dashboard_printbill?code_test=" + idNo
                        );
                    }}
                    iconBefore={<FaReceipt />}
                    appearance="primary"
                    intent="success"
                >
                    พิมพ์ใบแจ้งชำระเงินค่าสมัคร
                </Button>

                <Button
                    onClick={() => {
                        window.open(
                            `https://e-payment.kpru.ac.th/pay/typepayment?comp=80427&orderRef1=${idNo}&amount=${amount}&endDate=${stopDate}&urlredirect=https://admission.kpru.ac.th/admission/Dataregister&term=${term}&name=${fname}&lname=${lname}`
                        );
                    }}
                    iconBefore={<IoQrCodeOutline />}
                    appearance="primary"
                >
                    ชำระเงินค่าสมัครออนไลน์
                </Button>
            </Pane>

            <Pane display="flex" justifyContent="center">
                <img
                    className="col-4"
                    src="https://e-payment.kpru.ac.th/pay/public/images/Visa_Mastercard_jcb.jpg"
                    alt="peyment credit"
                />
                <img
                    className="col-4"
                    src="https://e-payment.kpru.ac.th/pay/public/images/logo_ktb_next.png"
                    alt="krungthai Next"
                />
                <img
                    className="col-4"
                    src="https://e-payment.kpru.ac.th/pay/public/images/promtpay1.png"
                    style={{ width: "100px" }}
                    alt="promtpay"
                />
            </Pane>
        </Dialog>
    );
}
